// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsMultiLanguageSettingsValidateTranslationUsageResult = objectOf({
  warnings: objectOf({
    incorrect_html_class_wrapping: arrayOf(string),
    query_param_in_translation: arrayOf(string),
    href_in_translation: arrayOf(string),
    url_protocol_in_translation: arrayOf(string),
    landing_page_liquid_in_translation: arrayOf(string),
    translation_tag_in_href: arrayOf(string),
  }),
});
